module.exports = __webpack_public_path__ + "img/jbt3411_32_1999.prt.a731e6bc.jpg";